import { useWarnAboutChange } from "@refinedev/core";
import { config } from "@src/config";
import React from "react";

export const useBlockNavigateUnSave = () => {
  const { setWarnWhen, warnWhen } = useWarnAboutChange();
  React.useEffect(() => {
    if (!warnWhen) return;

    window.history.pushState(null, document.title, location.href);

    const popstateListener = (event: PopStateEvent) => {
      event.preventDefault();
      if (window.confirm(config.UNSAVE_WARNING_MESSAGE)) {
        setWarnWhen?.(false);
        window.history.back();
      } else {
        window.history.pushState(null, document.title, location.href);
      }
    };

    addEventListener("popstate", popstateListener);

    return () => {
      removeEventListener("popstate", popstateListener);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, warnWhen]);
  return {
    setWarnWhen,
  };
};
